import React from 'react';
import {Box, Typography} from '@mui/material';
import {SettingsDialog} from '../settings/SettingsDialog';
import {getSettingsColors} from '../settings/SettingsDesign';

export function ColumnDialog({sx = [], ...props}) {
    return <SettingsDialog {...props} sx={[{
        '& .MuiDialogTitle-root + .MuiDialogContent-root': {pt: 1.5},
        '& .MuiDialogContent-root': {position: 'relative', minWidth: 0},
        '& .MuiDialog-paper': {
            '& .MuiTextField-root': {my: 0},
            '& .MuiOutlinedInput-root': {bgcolor: theme => theme.palette.mode === 'light'
                ? theme.palette.background.paper : getSettingsColors(theme).input},
            '& .MuiOutlinedInput-input': {fontSize: 13},
            '& .MuiButton-root': {textTransform: 'none', boxShadow: 'none', minHeight: 36},
            '& .MuiAlert-root': {borderRadius: '10px', fontSize: 13}
        }
    }, ...(Array.isArray(sx) ? sx : [sx])]}/>;
}

export function ColumnSection({title, description, count, children}) {
    const titleId = React.useId();
    return <Box component="section" aria-labelledby={titleId} sx={{p: {xs: 2, sm: 2.5},
        borderRadius: '12px', minWidth: 0, bgcolor: theme => getSettingsColors(theme).inset}}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
            <Typography component="h3" id={titleId} sx={{fontSize: 14, fontWeight: 600}}>{title}</Typography>
            {count !== undefined && <Box component="span" sx={{px: 0.75, py: 0.25, borderRadius: '6px',
                fontSize: 11, fontWeight: 600, color: 'text.secondary',
                bgcolor: theme => getSettingsColors(theme).card}}>{count}</Box>}
        </Box>
        {description && <Typography sx={{mt: 0.5, fontSize: 13, color: 'text.secondary', lineHeight: 1.6}}>
            {description}
        </Typography>}
        <Box sx={{mt: 2, minWidth: 0}}>{children}</Box>
    </Box>;
}

export const columnRowStyles = {
    p: 1.25, borderRadius: '8px', minWidth: 0,
    bgcolor: theme => getSettingsColors(theme).card,
    display: 'flex', alignItems: 'center', gap: 1
};
